export const cilMediaStop = ["24 24","<path d='M19.125 3.75h-14.25c-0.621 0-1.125 0.504-1.125 1.125v0 14.25c0 0.621 0.504 1.125 1.125 1.125v0h14.25c0.621 0 1.125-0.504 1.125-1.125v0-14.25c0-0.621-0.504-1.125-1.125-1.125v0zM18.75 18.75h-13.5v-13.5h13.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-media-stop.js
// module id = null
// module chunks = 